const AMOUNT = 'amount';
const CONSIGNMENT = 'consignment';
const H = 'h';
const KG = 'kg';
const M = 'm';
const MM = 'mm';
const M2 = 'm2';
const MM2 = 'mm2';

export { AMOUNT, CONSIGNMENT, H, KG, M, M2, MM2, MM };
